import type { HelpArticle } from '../../../components/help/types';

export const glossaryArticles: HelpArticle[] = [
  {
    id: 'glossary-terms',
    title: 'Glossary of Terms',
    summary: 'Definitions of common terms used in the system.',
    category: 'glossary',
    order: 1,
    keywords: ['glossary', 'terms', 'definitions', 'vocabulary', 'meaning'],
    content: `
# Glossary of Terms

Common terms and their definitions.

## A

**Approval Workflow**: A defined process for routing documents through approvers for authorization.

**Archive**: Long-term storage of documents that are no longer actively used but must be retained.

## C

**Classification**: Security level assigned to documents (Unclassified, Restricted, Confidential, Secret, Top Secret).

**Custodian**: The person currently responsible for a physical file jacket.

## D

**Department**: Organizational unit within an MDA.

**Document Type**: Category of document (Letter, Memo, Report, etc.).

## J

**Jacket**: Physical folder containing an employee's personnel documents.

## M

**MDA**: Ministry, Department, or Agency - an institutional unit in Ghana's civil service.

**Metadata**: Information about a document (title, author, date, classification, etc.).

## P

**PFile**: Personnel File - comprehensive record of a staff member.

**Platform Administrator**: User with access to manage the entire OHCS platform.

## R

**Registry**: Central location where physical file jackets are stored.

**Retention**: Policy defining how long documents must be kept.

**Role**: Set of permissions assigned to users.

## V

**Version**: Iteration of a document after changes are made.

## W

**Workflow Template**: Predefined approval process that can be applied to documents.
    `,
  },
];
